type TranslateFn = (key: string, defaultValue?: string) => string;

const UNIQUE_PRODUCTS_KEYS: Record<string, string> = {
  "50": "settings.plan_features.unique_products_50",
  "500": "settings.plan_features.unique_products_500",
  "5000": "settings.plan_features.unique_products_5000",
  "25000": "settings.plan_features.unique_products_25000",
};

const PREMIUM_PRODUCTS_KEYS: Record<string, string> = {
  "25": "settings.plan_features.premium_products_25",
  "250": "settings.plan_features.premium_products_250",
  "2500": "settings.plan_features.premium_products_2500",
  "25000": "settings.plan_features.premium_products_25000",
};

const normalizeDigits = (value: string): string => value.replaceAll(",", "");
const NUMBER_WITH_OPTIONAL_BOLD_TAG =
  "(?:<(?:b|strong)>\\s*)?(\\d[\\d,]*)(?:\\s*<\\/(?:b|strong)>)?";
const WORD_WITH_OPTIONAL_BOLD_TAG = (word: string): string =>
  `(?:<(?:b|strong)>\\s*)?${word}(?:\\s*<\\/(?:b|strong)>)?`;

export const translatePlanFeature = (feature: string, t: TranslateFn): string => {
  let translatedFeature = feature;

  translatedFeature = translatedFeature.replace(
    new RegExp(
      `${NUMBER_WITH_OPTIONAL_BOLD_TAG}\\s+unique\\s+products`,
      "gi"
    ),
    (fullMatch, numberText: string) => {
      const key = UNIQUE_PRODUCTS_KEYS[normalizeDigits(numberText)];
      return key ? t(key, fullMatch) : fullMatch;
    }
  );

  translatedFeature = translatedFeature.replace(
    new RegExp(
      `${NUMBER_WITH_OPTIONAL_BOLD_TAG}\\s+premium\\s+products`,
      "gi"
    ),
    (fullMatch, numberText: string) => {
      const key = PREMIUM_PRODUCTS_KEYS[normalizeDigits(numberText)];
      return key ? t(key, fullMatch) : fullMatch;
    }
  );

  [
    {
      regex: new RegExp(
        `${WORD_WITH_OPTIONAL_BOLD_TAG("winning")}\\s+${WORD_WITH_OPTIONAL_BOLD_TAG("products")}`,
        "gi"
      ),
      key: "settings.plan_features.winning_products",
      fallback: "Winning products",
    },
    {
      regex: new RegExp(
        `${WORD_WITH_OPTIONAL_BOLD_TAG("product")}\\s+${WORD_WITH_OPTIONAL_BOLD_TAG("optimizer")}`,
        "gi"
      ),
      key: "settings.plan_features.product_optimizer",
      fallback: "Product optimizer",
    },
    {
      regex: new RegExp(
        `${WORD_WITH_OPTIONAL_BOLD_TAG("vip")}\\s+${WORD_WITH_OPTIONAL_BOLD_TAG("chat")}\\s+${WORD_WITH_OPTIONAL_BOLD_TAG("support")}`,
        "gi"
      ),
      key: "settings.plan_features.vip_chat_support",
      fallback: "VIP Chat Support",
    },
  ].forEach(({ regex, key, fallback }) => {
    translatedFeature = translatedFeature.replace(regex, t(key, fallback));
  });

  return translatedFeature;
};
